import type { App } from 'vue'
import { use } from 'echarts/core'
import { BarChart, PieChart } from 'echarts/charts'
import { CanvasRenderer } from 'echarts/renderers'
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent
} from 'echarts/components'

export default {
  install: (app: App<Element>) => {

    use([
      TitleComponent,
      TooltipComponent,
      LegendComponent,
      GridComponent,
      BarChart,
      PieChart,
      CanvasRenderer
    ])

  }
}
